import React, { useState, useEffect, useRef } from 'react';
import viewEvents from '../../helpers/viewEvents';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../ui/Modal';

export default () => {
    const [popupElements, setPopupElements] = useState<boolean | null>(null);
    const [data, setData] = useState<Record<string, any>>({});
    const history = useNavigate();
    const openPopupHandler = (e) => {
        setData(e.detail.payload);
        setPopupElements(true);
    };
    useEffect(() => {
        viewEvents.listen('#root', 'openPopup', openPopupHandler);
        const { onMount = () => undefined, onUnmount = () => undefined } = data;

        onMount();
        return () => {
            //executed on destroy
            viewEvents.destroy('#root', 'openPopup', openPopupHandler);
            onUnmount();
        };
    }, [popupElements]);

    return (
        data.component && (
            <Modal
                useFlexLayout={false}
                open={popupElements}
                onOpenChange={(e: any) => {
                    // e.preventDefault();
                    setPopupElements(false);
                    if (data.screen && data.screen === 'vodplayer') {
                        history(-1);
                    }
                }}
                closePlacement="end"
                widthSet="medium"
            >
                {data.component}
            </Modal>
        )
    );
};
